import { c as _c } from "react/compiler-runtime";
import React from "react";
import { useIntl } from "react-intl";
import { useFormMode } from "forms/contexts/useFormModeContext";
import { FormModeValues } from "types/formMode";
import { Button } from "uiShadcn/button";
interface IProps {
  isLoading: boolean;
  isSubmitting: boolean;
}
export default function SubmitButton(t0) {
  const $ = _c(11);
  const {
    isLoading,
    isSubmitting
  } = t0;
  const {
    formatMessage
  } = useIntl();
  const mode = useFormMode();
  const t1 = isLoading || isSubmitting;
  let t2;
  if ($[0] !== t1) {
    t2 = {
      disabled: t1,
      dataTestId: "formSubmitButton",
      variant: "theme",
      className: "w-full md:max-w-[320px]"
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const buttonProps = t2;
  const t3 = isSubmitting ? "loading" : "send";
  let t4;
  if ($[2] !== formatMessage || $[3] !== t3) {
    t4 = formatMessage({
      id: t3
    });
    $[2] = formatMessage;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const label = t4;
  if (mode === FormModeValues.Form) {
    let t5;
    if ($[5] !== buttonProps || $[6] !== label) {
      t5 = <Button type="submit" {...buttonProps}>{label}</Button>;
      $[5] = buttonProps;
      $[6] = label;
      $[7] = t5;
    } else {
      t5 = $[7];
    }
    return t5;
  }
  let t5;
  if ($[8] !== buttonProps || $[9] !== label) {
    t5 = <Button type="button" {...buttonProps}>{label}</Button>;
    $[8] = buttonProps;
    $[9] = label;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}